

export const environment = {
  isTestMode: false
};
